import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useCurrentRoute } from 'react-navi';
import { DEFAULT_PAGE_TITLE } from '../helpers';
import type { ISeoMetadata } from './helpers';
import { getSeoMetadata } from './helpers';

const SeoMetadata = () => {
  const {
    url: { pathname },
    title: routeTitle,
  } = useCurrentRoute();

  const {
    i18n: { language },
    t,
  } = useTranslation();

  const fallbackTitle =
    typeof routeTitle === 'function'
      ? routeTitle(t)
      : (routeTitle ?? DEFAULT_PAGE_TITLE);

  const [meta, setMeta] = useState<ISeoMetadata | undefined>();

  useEffect(() => {
    setMeta(undefined);
    getSeoMetadata(language, pathname).then(setMeta);
  }, [language, pathname]);

  const title = meta?.title ?? fallbackTitle;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {meta?.description && (
        <meta content={meta.description} name="description" />
      )}
    </Helmet>
  );
};

export default SeoMetadata;
